import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.25),
  padding: (p) => p.spacing(0.25, 0.5),
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
